import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

import { CoreInputProps } from './CoreInput';

interface TrailingVisualWrapperProps extends Pick<CoreInputProps, 'disabled'> {}

export const TrailingVisualWrapper = styled.div<TrailingVisualWrapperProps>`
    padding-right: ${theme.space[8]};
    font-weight: ${theme.fontWeights[600]};
    display: flex;
    align-items: center;
    color: ${(props) => (props.disabled ? theme.colors.foreground.disabled : theme.colors.foreground.default)};
`;
